import Button from "@/components/button"
import { Icon } from "@/icons/icon"
import { cn } from "@/lib/utils"
import { ShiftStatus } from "@/store/session"
import { format } from "date-fns"

export interface DraftCardProps {
  processId: string
  status: ShiftStatus
  plantName: string
  updatedAt: string
  className?: string
  onClick?: (processId: string) => void | Promise<void>
}

export default function DraftCard({
  className,
  processId,
  updatedAt,
  status,
  onClick,
}: DraftCardProps) {
  function formatTime(date: Date) {
    try {
      return format(date, "HH:mm")
    } catch {
      return "---"
    }
  }

  function getBtnText() {
    if (status === ShiftStatus.Started || status === ShiftStatus.Draft) {
      return "Continue with Draft"
    }

    if (status === ShiftStatus.Ended) {
      return "View Process"
    }

    return "Start Process"
  }

  function getStatusText() {
    if (status === ShiftStatus.Inactive) {
      return "To be started"
    }

    if (status !== ShiftStatus.Ended) {
      return "Pending"
    }

    return "Completed"
  }

  function getIndicatorColor() {
    if (status !== ShiftStatus.Ended) {
      return "#FAA226CC"
    }

    return "#82DFA1"
  }

  async function handleClickBtn() {
    if (onClick) {
      await onClick(processId)
    }
  }

  return (
    <article
      className={cn(
        "border border-l-border rounded-lg bg-white p-4",
        className
      )}
    >
      <div className="flex">
        <div className="flex gap-3">
          <div className="flex flex-col gap-3">
            {updatedAt && (
              <div className="flex gap-3">
                <div
                  className="
                  size-10.5 bg-backdrop rounded-full 
                  flex items-center justify-center
                "
                >
                  <Icon name="Draft" className="w-8 h-auto text-button-black" />
                </div>

                <div>
                  <div className="text-label-text text-sm font-medium leading-5.5">
                    Last Edit Time
                  </div>
                  <div className="text-button-black text-base font-medium leading-5.5">
                    {formatTime(new Date(updatedAt))}
                  </div>
                </div>
              </div>
            )}

            <div className="flex items-center gap-3">
              <div className="size-10 flex items-center justify-center">
                <div
                  className={cn("size-3.5 rounded-full")}
                  style={{ backgroundColor: getIndicatorColor() }}
                ></div>
              </div>

              <div>
                <div className="text-label-text text-sm font-medium leading-5.5">
                  Status
                </div>
                <div className="text-button-black text-base font-medium leading-5.5 flex gap-2">
                  {getStatusText()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Button className="w-full mt-6" onClick={handleClickBtn}>
        {getBtnText()}
      </Button>
    </article>
  )
}
